import RouteActions from '../actions/routeActions';

function routeReducer(state = {
    appHistory: null,
}, action) {

    switch (action.type) {
        case RouteActions.appRoute:
            return {
                appHistory: action.payload,
            }
        default:
            return state;
    }
}

export default routeReducer;


// WEBPACK FOOTER //
// ./src/store/reducer/routereducer.js